import { z } from "zod";

export const ValuationInput = z.object({
  address: z.string().min(5).max(300),
  city: z.string().min(2).max(120),
  property_type: z.enum(["appartamento", "villa", "attico", "rustico"]),
  mq: z.number().positive().max(5000),
  year_built: z.number().int().min(1700).max(2050),
  energy_class: z.enum(["A4","A3","A2","A1","B","C","D","E","F","G"]),
  rooms: z.number().int().min(1).max(40),
  state: z.enum(["nuovo", "ottimo", "buono", "da_ristrutturare"]).default("buono"),
  email: z.string().email().optional(),
  turnstile_token: z.string().min(10),
});
export type ValuationInput = z.infer<typeof ValuationInput>;

export const ValuationOutput = z.object({
  low: z.number(),
  expected: z.number(),
  high: z.number(),
  ipe_estimated: z.number(),
  confidence: z.number().min(0).max(1),
  disclaimer_id: z.string(),
  baseline_eur_per_mq: z.number(),
  applied_factors: z.array(z.object({
    factor: z.string(),
    multiplier: z.number(),
    reason: z.string(),
  })),
});
export type ValuationOutput = z.infer<typeof ValuationOutput>;
